export enum INVENTORY_FILTER {
  ALL = 'all',
  ASSIGNED = 'assigned',
  ONLY_ASSIGNED = 'onlyAssigned',
}

export enum SORT_BY {
  NAME = 'name',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}
